import { supabase } from '@/lib/supabase';

// Ảnh CCCD khách hàng — lưu ở bảng customer_images (thay localStorage cũ)
// để đồng bộ giữa các thiết bị.

export interface CustomerImages {
  front?: string;
  back?: string;
}

// Đọc từ localStorage cũ để migrate 1 lần (nếu có)
function readLegacy(id: string): CustomerImages {
  try {
    const raw = localStorage.getItem(`cccd_${id}`);
    return raw ? (JSON.parse(raw) as CustomerImages) : {};
  } catch {
    return {};
  }
}

export async function fetchCustomerImages(customerId: string): Promise<CustomerImages> {
  const { data, error } = await supabase
    .from('customer_images')
    .select('front, back')
    .eq('customer_id', customerId)
    .maybeSingle();

  if (error) {
    console.warn('customer_images chưa sẵn sàng:', error.message);
    return readLegacy(customerId);
  }

  // Có row trên DB → dùng
  if (data && (data.front || data.back)) {
    return { front: data.front || undefined, back: data.back || undefined };
  }

  // DB trống → thử migrate từ localStorage cũ lên DB (1 lần)
  const legacy = readLegacy(customerId);
  if (legacy.front || legacy.back) {
    await saveCustomerImages(customerId, legacy.front, legacy.back);
    return legacy;
  }
  return {};
}

export async function saveCustomerImages(
  customerId: string,
  front?: string,
  back?: string
): Promise<void> {
  const { error } = await supabase.from('customer_images').upsert({
    customer_id: customerId,
    front: front || '',
    back: back || '',
    updated_at: new Date().toISOString(),
  });
  if (error) {
    console.warn('Lưu ảnh CCCD thất bại:', error.message);
    // Fallback localStorage để không mất ảnh
    try {
      localStorage.setItem(`cccd_${customerId}`, JSON.stringify({ front, back }));
    } catch {
      // ignore
    }
    return;
  }
  // Xoá legacy key sau khi lưu DB thành công
  try {
    localStorage.removeItem(`cccd_${customerId}`);
  } catch {
    // ignore
  }
}

export async function deleteCustomerImages(customerId: string): Promise<void> {
  await supabase.from('customer_images').delete().eq('customer_id', customerId);
  try {
    localStorage.removeItem(`cccd_${customerId}`);
  } catch {
    // ignore
  }
}
